import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {delay, takeUntil} from "rxjs/operators";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validIban} from "../../../../shared/validator/iban-validator";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {PartnerService} from "../../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  ChangeRegionalDialogData
} from "../../../partners/change-account-number-dialog/change-account-number-dialog.component";
import {ReplaySubject} from "rxjs";
import {Partner} from "../../../../shared/interface/partner";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";

export interface ChangeRegistrationDialogData {
  receivablesObject: ReceivablesImportRow;
  insuranceCompany: InsuranceCompany;
}

@Component({
  selector: 'app-change-registration-dialog',
  templateUrl: './change-registration-dialog.component.html',
  styleUrls: ['./change-registration-dialog.component.scss']
})
export class ChangeRegistrationDialogComponent implements OnInit, OnDestroy  {

  changeRegistrationForm: FormGroup;
  receivablesObject: ReceivablesImportRow;
  insuranceCompany: InsuranceCompany;
  processingRequest = false;
  registrationControl: FormControl;
  enableSaveButton = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeRegistrationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegistrationDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private receivablesImportsRowService: ReceivablesImportsRowService,
    private snack: MatSnackBar
  ) {
    this.receivablesObject = data.receivablesObject;
    this.insuranceCompany = data.insuranceCompany;
    this.changeRegistrationForm = fb.group({
      registration: this.registrationControl = fb.control('', [Validators.required ]),
    });
  }

  ngOnInit(): void {
    this.changeRegistrationForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeRegistrationForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  sendForm(): void {
    this.processingRequest = true;

    this.receivablesImportsRowService.changeRegistration(this.changeRegistrationForm.value, this.receivablesObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono rejestracje', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu polisy wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
